import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { type FC, type ReactNode } from "react";

interface SortableItemProps {
  id: string;
  data?: Record<string, unknown>;
  children: (dragHandleProps: Record<string, unknown>) => ReactNode;
}

export const SortableItem: FC<SortableItemProps> = ({ id, data, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id, data });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    zIndex: isDragging ? 10 : undefined,
  };

  return (
    <div ref={setNodeRef} style={style}>
      {children({ ...listeners, ...attributes })}
    </div>
  );
};
